module.exports = __webpack_public_path__ + "img/bpifrance-logo250x250.46e100dc.png";